import {Directive, ElementRef, OnInit, Input, Output, EventEmitter} from '@angular/core';

declare var $:any;

@Directive({
  selector: '[saUiDatepicker]'
})
export class UiDatepickerDirective implements OnInit {

    @Input() saUiDatepicker: any;

    @Output()
    change: EventEmitter<string> = new EventEmitter();

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        let onSelectCallbacks = [];
        let saUiDatepicker = this.saUiDatepicker || {};
        let element = $(this.el.nativeElement);

        if (saUiDatepicker.minRestrict) {
            onSelectCallbacks.push((selectedDate) => {
                $(saUiDatepicker.minRestrict).datepicker('option', 'minDate', selectedDate);
            });
        }
        if (saUiDatepicker.maxRestrict) {
            onSelectCallbacks.push((selectedDate) => {
                $(saUiDatepicker.maxRestrict).datepicker('option', 'maxDate', selectedDate);
            });
        }

        //Let others know about changes to the data field
        onSelectCallbacks.push((selectedDate) => {
            element.triggerHandler("change");

            let form = element.closest('form');

            if (typeof form.bootstrapValidator == 'function') {
                try {
                    form.bootstrapValidator('revalidateField', element);
                } catch (e) {
                    console.log(e.message)
                }
            }
        });

        let options = $.extend(saUiDatepicker, {
            prevText: '<i class="fa fa-chevron-left"></i>',
            nextText: '<i class="fa fa-chevron-right"></i>',
            onSelect: (selectedDate) => {
                this.change.emit(selectedDate);
                onSelectCallbacks.forEach((callback) => {
                    callback.call(callback, selectedDate)
                })
            }
        });

        if (!!options.altField && !$(options.altField).length) {
            let idEl: string = "altDatepicker-" + new Date().getTime();
            if (/#/.test(options.altField)) {
                idEl = options.altField.replace(/#/, "")
            }

            let ngContentAttr = "";
            $.each(element[0].attributes, (index, attribute) => {
                if (/\_ngcontent/.test(attribute.nodeName)) ngContentAttr += attribute.nodeName + " ";
            });

            let inputAlt = $('<input ' + ngContentAttr + ' [altDatepicker]="\'' + (element.attr("id") ? "#" + element.attr("id") : "") + '\'">')
                .attr({
                    id: idEl,
                    style: element.attr("style"),
                    class: element.attr("class"),
                    readonly: "readonly"
                });
            element.after(inputAlt);
            element.hide();

            inputAlt.on("click", () => element.datepicker("show"));
        }

        element.datepicker(options);
    }
}